<span
  #iconRef
  *ngxClipboardIfSupported
  ngxClipboard
  inlineSVG="./assets/media/icons/duotune/general/gen054.svg"
  [class]="'svg-icon svg-icon-' + size + ' cursor-pointer p-1 rounded copy-text__icon'"
  [cbContent]="content"
  (cbOnSuccess)="onCopied()"
></span>
